(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallResultGroupDetailController', PhoneCallResultGroupDetailController);

    /* Added UIFormAccess
    PhoneCallResultGroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallResultGroup', 'PhoneCallResult'];

    function PhoneCallResultGroupDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallResultGroup, PhoneCallResult) {
    */
    PhoneCallResultGroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallResultGroup', 'PhoneCallResult', 'UIFormAccess'];

    function PhoneCallResultGroupDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallResultGroup, PhoneCallResult, UIFormAccess) {
        var vm = this;

        vm.phoneCallResultGroup = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:phoneCallResultGroupUpdate', function(event, result) {
            vm.phoneCallResultGroup = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
